import PropTypes from 'prop-types'

// A row↔chart echo boundary for a composite block whose areas sit as bare siblings under one
// BlockWrapper: pointHalo pairs a table with the nearest chart inside the closest boundary, and
// without one the walk reaches a neighbouring area's chart. `display: contents` keeps the wrapper
// out of the plate's layout.
// `name` is the second thing the boundary is good for: the areas of a composite block render the
// same components under the same classes and are otherwise told apart only by the copy on their
// labels, so the boundary is where the area gets to say which one it is.
const EchoScope = ({ children, name }) => (
  <div data-echo-scope data-sub-block={name} style={{ display: 'contents' }}>
    {children}
  </div>
)

EchoScope.propTypes = { children: PropTypes.node, name: PropTypes.string }

EchoScope.displayName = 'EchoScope'

export default EchoScope
